/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphGanttIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Gantt',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx="1" ry="1" width="8" />
    <rect height="4" rx="1" ry="1" width="18" x="6" y="6" />
    <rect height="4" rx="1" ry="1" width="8" x="10" y="12" />
    <rect height="4" rx="1" ry="1" width="6" x="14" y="18" />
    <rect height="4" rx="1" ry="1" width="16" x="14" y="24" />
    <rect height="4" rx="1" ry="1" width="18" x="18" y="30" />
  </svg>`;
};
